export { default as menuRouter } from './menuRouter/index';
export { default as platformReception } from './platformReception/index';
export { default as message } from './message/index';
export { encodeWindowName, decodeWindowName } from './childWindowName/index';
